import { render, staticRenderFns } from "./BotExpressModal.vue?vue&type=template&id=48a3dfe4&scoped=true&"
import script from "./BotExpressModal.vue?vue&type=script&lang=js&"
export * from "./BotExpressModal.vue?vue&type=script&lang=js&"
import style0 from "./BotExpressModal.vue?vue&type=style&index=0&id=48a3dfe4&lang=scss&scoped=true&"
import style1 from "./BotExpressModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a3dfe4",
  null
  
)

export default component.exports